var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:{
    'disable-link-styles no-letter-spacing rounded-pill text-transform-none ': true,
    'primary white--text': _vm.invert,
    'primary--text text--darken-1': !_vm.invert && !_vm.disabled,
    'green-gradient-right': _vm.gradient && !_vm.secondary && !_vm.disabled,
    'orange-gradient-right': _vm.gradient && _vm.secondary && !_vm.disabled,
    'secondary white--text': _vm.disabled,
    inactive: _vm.inactive
  },attrs:{"disabled":_vm.disabled,"to":_vm.to,"width":_vm.width,"loading":_vm.loading,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }